import {createContext, useEffect, useState} from 'react';
import axios from 'axios';

const AuthContext = createContext({});

axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;
if (localStorage && localStorage.authToken) {
    const access_token = localStorage.getItem('authToken');
    axios.defaults.headers.common['Authorization'] = `Token ${access_token}`;
}
axios.defaults.headers.post['Content-Type'] = 'application/json';

export const AuthProvider = ({children}) => {
    const [auth, setAuth] = useState({});
    const [me, setMe] = useState({});
    useEffect(() => {
        setAuth(localStorage.getItem('authToken'));
    }, [localStorage.getItem('authToken')]);
    return (
        <AuthContext.Provider value={{me, setMe, auth, setAuth}}>{children}</AuthContext.Provider>
    );
};

export default AuthContext;
